import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const COLORS = ['#e63946', '#a78bfa', '#60a5fa', '#34d399', '#fbbf24', '#fb923c']
const COUNT = 22

function makeParticles() {
  return Array.from({ length: COUNT }, (_, i) => {
    const angle = (i / COUNT) * Math.PI * 2 + (Math.random() - 0.5) * 0.5
    const dist = 50 + Math.random() * 80
    return {
      id: i,
      x: Math.cos(angle) * dist,
      y: Math.sin(angle) * dist,
      color: COLORS[i % COLORS.length],
      size: 4 + Math.random() * 5,
      isRect: Math.random() > 0.45,
      rotate: (Math.random() - 0.5) * 480,
      delay: Math.random() * 0.08,
    }
  })
}

export function CelebrationOverlay() {
  const [burst, setBurst] = useState(null) // { x, y, particles }

  useEffect(() => {
    const handler = (e) => {
      const origin = e.detail || { x: window.innerWidth / 2, y: window.innerHeight / 2 }
      setBurst({ ...origin, particles: makeParticles() })
      setTimeout(() => setBurst(null), 900)
    }
    window.addEventListener('task-completed', handler)
    return () => window.removeEventListener('task-completed', handler)
  }, [])

  return (
    <AnimatePresence>
      {burst && (
        <motion.div
          key="celebration"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.6 }}
          className="fixed inset-0 pointer-events-none"
          style={{ zIndex: 9998 }}
        >
          {/* Anchor everything at the click origin */}
          <div
            className="absolute"
            style={{ left: burst.x, top: burst.y, transform: 'translate(-50%, -50%)' }}
          >
            {/* Check ring pop */}
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: [0, 1.25, 1], opacity: [0, 1, 0] }}
              transition={{ duration: 0.55, times: [0, 0.38, 1], ease: 'easeOut' }}
              className="absolute rounded-full flex items-center justify-center"
              style={{
                width: 36, height: 36,
                marginLeft: -18, marginTop: -18,
                background: 'rgba(52,211,153,0.15)',
                border: '1.5px solid rgba(52,211,153,0.45)',
              }}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <motion.path
                  d="M3 8l3.5 3.5 6.5-7"
                  stroke="#34d399"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 0.3, delay: 0.08, ease: 'easeOut' }}
                />
              </svg>
            </motion.div>

            {/* Particle burst */}
            {burst.particles.map((p) => (
              <motion.div
                key={p.id}
                className="absolute"
                style={{
                  width: p.isRect ? p.size * 0.65 : p.size,
                  height: p.isRect ? p.size * 2.0 : p.size,
                  borderRadius: p.isRect ? 2 : '50%',
                  background: p.color,
                  left: -(p.isRect ? p.size * 0.65 : p.size) / 2,
                  top: -(p.isRect ? p.size * 2.0 : p.size) / 2,
                }}
                initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 1 }}
                animate={{ x: p.x, y: p.y, opacity: 0, rotate: p.rotate, scale: 0.2 }}
                transition={{ duration: 0.65, delay: p.delay, ease: [0.23, 1, 0.32, 1] }}
              />
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
